import { render, staticRenderFns } from "./UsuariosEdit.vue?vue&type=template&id=55fd3d3e&"
import script from "./UsuariosEdit.vue?vue&type=script&lang=js&"
export * from "./UsuariosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports